import { MembershipsDirectMessagesApiClient } from '@fourthwall/services/dist/MembershipsDirectMessagesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDirectMessagesSettingsQuery = createQueryHook(
  MembershipsDirectMessagesApiClient.getDirectMessagesSettings,
  {
    queryKey: ['directMessagesSettings'],
  },
)
